export const DEFAULT_GRID_ID = 'default'
